/**
 * Переводит первый символ строки в верхний регистр, остальные остаются без изменений.
 * @param {string} str Входная строка.
 * @returns {string} Строка с первым символом в верхнем регистре или пустая строка, если вход пуст.
 */

export function capitalize(str) {
    if (typeof str !== 'string' || str.length === 0) {
        return ''; // Возвращаем пустую строку для нестроковых значений или пустых строк
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Сокращаем длинную строку (например, UUID/GUID) до более читаемого вида
 * @param {string} str Исходная строка.
 * @param {number} [charsToShow=6] Количество символов для отображения в начале и в конце строки.
 * @returns {string} Сокращенная строка или исходная строка, если она достаточно коротка.
 */
export function shortenString(str, charsToShow = 6) {
    // Проверяем, является ли ввод строкой
    if (typeof str !== 'string') {
        return String(str); // Преобразуем в строку и возвращаем, чтобы избежать ошибок
    }

    const minLengthForShortening = charsToShow * 2 + 3;

    // Если строка короче, чем нужно для сокращения, возвращаем ее как есть
    if (str.length <= minLengthForShortening) {
        return str;
    }

    const start = str.substring(0, charsToShow);
    const end = str.substring(str.length - charsToShow);

    return `${start}....${end}`;
}